import { ProductionDetailProcessRoles } from '@app/models/roles/roles-group';

/**
 * Areas the Area Production Detail report can be filtered by.
 *
 * The values are the process keys the Production API expects in the `processes`
 * query param, and they must stay in sync with the `*ProcessKey` constants in
 * `ProductionDetailReportService` (Sierra.Production.Api).
 */
export enum ProductionDetailProcess {
  Knitting = 'Knitting',
  Dyeing = 'Dyeing',
  Finishing = 'Finishing',
}

/** Report order, matching the order of the sheets in the generated workbook. */
export const PRODUCTION_DETAIL_PROCESSES: readonly ProductionDetailProcess[] = [
  ProductionDetailProcess.Knitting,
  ProductionDetailProcess.Dyeing,
  ProductionDetailProcess.Finishing,
];

/** Role required to download each area. */
export const PRODUCTION_DETAIL_PROCESS_ROLES: Readonly<Record<ProductionDetailProcess, ProductionDetailProcessRoles>> = {
  [ProductionDetailProcess.Knitting]: ProductionDetailProcessRoles.ProductionDetailKnittingViewer,
  [ProductionDetailProcess.Dyeing]: ProductionDetailProcessRoles.ProductionDetailDyeingViewer,
  [ProductionDetailProcess.Finishing]: ProductionDetailProcessRoles.ProductionDetailFinishingViewer,
};
